import React from "react";
import { SVGAsset } from "res";
import {useParams} from "@bcm-dev/bcms-vite";
import {Card} from "model";
import "./styles.css";

/**
 * @function CardUserInformationWidget
 * @param {String} name - Allows us to set the name on the card 
 * @param {String} cardType - Allows us to set the type of card 
 * @param {String} cardLastFour - Allows us to set the last four digits of the card
 * @return {React.Component}
 * @exported true
 * @description The CardUserInformationWidget shows a card icon with the name, card type, and last four digits of the card.
 * @example
 * <CardUserInformationWidget name="George Washington" cardType="Debit" cardLastFour="*1234" />
 */

export default function CardUserInformationWidget(props) {
  const cardID = useParams().cardID ?? "0";
 
  const selectedCard = Card.initByID(cardID);
  const name = selectedCard.owner ?? "[Patricia Knight]";
  const cardType = selectedCard.type ?? "[Debit]";
  const cardLastFour = selectedCard.lastFour ?? "[*1234]";

  return(
    <div className="card-user-information-widget flex-container flex-horizontal align-center-container bottom-border">
      <SVGAsset id="CardOutlineIcon" className="set-width left-icon-container" />
      <div className="user-info-container flex-container flex-vertical align-left justify-center flex-width">
        <p className="card-name">{name}</p>
        <p className="sub-text">{cardType} *{cardLastFour}</p>
      </div>
    </div>
  );
}